import * as React from 'react';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Input, InputNumber, Checkbox, Transfer, Switch } from 'antd';
import Select from './Select';
import SelectExtend from './SelectExtend';
import Address from './Address';
import DynamicSelect, { AreaSelectInput } from './DynamicSelect';
import RadioGroup from './RadioGroup';
import DatePicker from './DatePicker';
import RichText from './RtText';
import Upload, { ExcelUpload, FileUpload } from './Upload';
import UploadNew, { FileUploadNew } from './UploadNew';
import EncryptUpload from './EncryptUpload';
import EncryptUploadMulti from './EncryptUploadMulti';
import CheckBoxInput from './CheckBoxInput';
import Phone from './Phone';
import PhoneTemp from './PhoneTemp';
import Certificate from './Certificate';
import Code from './Code';
import ImgCode from './ImgCode';
import Cascade from './Cascade';
import InsertText from './InsertText';
import Password from './Password';
import Signature from './Signature';
const TextArea = Input.TextArea;
const CheckboxGroup = Checkbox.Group;
import Captcha from './Captcha';
import TreeSelect from './TreeSelect';
import InputView from './Input';
import IconsPicker from './IconsPicker';
import BgImg from './BgImg';
import Match from '../../User';
import Transform from './Transform';
import SelectGroup from './InputGroup';
import SelectSearch from './SelectSearch';
import InsertRadio from './insertRadio';
import InsertSwitch from './InsertSwitch';
import ComplexAddress from './ComplexAddress';
import SelectInput from './SelectInput';

export default (config: any, decorator: (options?: object) => Function) => {
    switch (config.type) {
    case 'text': {
        return decorator({
            getValueFromEvent:config.getValueFromEvent ? config.getValueFromEvent : undefined
        })(<InputView placeholder={config.placeholder} tooltip={config.tooltip} name={config.name}
                                      wrapBool={config.wrapBool}
                                      addonAfter={config.addonAfter} onChange={config.onChange}
                                      limitations={config.limitations}
                                      disabled={config.disabled} initialValue={config.defaultValue}
                                      readOnly={config.readOnly} onBlur={config.onBlur}
                                      addonBefore={config.addonBefore} copy={config.copy} link={config.link}
                                      maxLength={config.maxLength}
                                      showDecrypt={config.showDecrypt} decryptConfig={config.decryptConfig}
                                      staticView={config.staticView} filter={config.filter} href={config.href}
                                      target={config.target}
                                      nameConfig={config.nameConfig} showName={config.showName}/>);
    }
    case 'select': {
        let decoratorOptions = config.getValueFromEvent ? {
            getValueFromEvent:config.getValueFromEvent
        } : undefined;
        return decorator(
            decoratorOptions
        )(<Select placeholder={config.placeholder} options={config.options}
                                   initialValue={config.defaultValue} onDeselect={config.onDeselect}
                                   allowClear={config.allowClear} disabled={config.disabled} onSelect={config.onSelect}
                                   onChange={config.onChange}
                                   dropdownStyle={config.dropdownStyle}
                                   getPopupContainer={config.getPopupContainer}
                                   mode={config.mode} size={config.size} staticView={config.staticView}
                                   link={config.link} readOnly={config.readOnly}/>);
    }
    case 'selectExtend': {
        let decoratorOptions = config.getValueFromEvent ? {
            getValueFromEvent:config.getValueFromEvent
        } : undefined;
        return decorator(
            decoratorOptions
        )(<SelectExtend placeholder={config.placeholder} options={config.options} addOption={config.addOption} inputPlaceholder={config.inputPlaceholder}
                                   initialValue={config.defaultValue} onDeselect={config.onDeselect}
                                   allowClear={config.allowClear} disabled={config.disabled} onSelect={config.onSelect}
                                   onChange={config.onChange}
                                   dropdownStyle={config.dropdownStyle}
                                   getPopupContainer={config.getPopupContainer}
                                   mode={config.mode} size={config.size} staticView={config.staticView}
                                   link={config.link} readOnly={config.readOnly}/>);
    }
    case 'selectSearch': {
        return decorator()(<SelectSearch placeholder={config.placeholder} options={config.options}
                                         initialValue={config.defaultValue} onDeselect={config.onDeselect}
                                         allowClear={config.allowClear} disabled={config.disabled}
                                         onSelect={config.onSelect}
                                         onChange={config.onChange}
                                         key={config.key}
                                         onSearch={config.onSearch}
                                         callback={config.callback}
                                         mode={config.mode} size={config.size} staticView={config.staticView}
                                         link={config.link} readOnly={config.readOnly}/>);
    }
    case 'treeSelect': {
        return decorator({
            validateTrigger: 'onChange'
        })(<TreeSelect url={config.url} treeData={config.treeData} adaptFn={config.adaptFn} strategy={config.strategy}
                       heightLimit={config.heightLimit} treeDefaultExpandedKeys={config.treeDefaultExpandedKeys}
                       initData={config.initData} placeholder={config.placeholder}
                       onChange={config.onChange} staticView={config.staticView}
                       treeCheckable={config.treeCheckable} size={config.size}
                       getPopupContainer={config.getPopupContainer}
                       multiple={config.multiple} targetKeys={config.targetKeys}
                       labelInValue={config.labelInValue} dropdownClassName={config.dropdownClassName}
                       allowClear={config.allowClear} disabled={config.disabled}
                       treeDefaultExpandAll={config.treeDefaultExpandAll}
                       loadData={config.loadData} treeDataSimpleMode={config.treeDataSimpleMode}/>);
    }
    case 'radioGroup': {
        return decorator()(RadioGroup(config));
    }
    case 'datePicker': {
        return decorator()(<DatePicker disabled={config.disabled} showToday={config.showToday}
                                       showTime={config.showTime} disabledDate={config.disabledDate}
                                       disabledTime={config.disabledTime} customKey={config.customKey}
                                       size={config.size} format={config.format} staticView={config.staticView}/>);
    }
    case 'richText': {
        return decorator()(<RichText enabledImage={config.enabledImage} disabled={config.disabled}
                                     className={config.className} wrap={config.wrap}
                                     encode={config.encode} format={config.format} lang={config.lang}
                                     onChange={config.onChange} onCall={config.onCall}
                                     extra={config.extra} staticView={config.staticView} href={config.href}
                                     target={config.target} menu={config.menu} isRelativeUrl={config.isRelativeUrl}
                                     thumbnail={config.thumbnail}/>);
    }
    case 'upload': {
        return decorator()(<Upload action={config.action} max={config.max} discompress={config.discompress}
                                   disabled={config.disabled} onPreview={config.onPreview}
                                   tips={config.tips} addClass={config.addClass} onChange={config.onChange}
                                   transBg={config.transBg}
                                   widthAuto={config.widthAuto}/>);
    }
    case 'uploadNew': {
        return decorator()(<UploadNew action={config.action} max={config.max} discompress={config.discompress} fileList={config.fileList}
                                   disabled={config.disabled} onPreview={config.onPreview}  before={config.before} limitType={config.limitType}
                                   tips={config.tips} addClass={config.addClass} onChange={config.onChange}
                                   transBg={config.transBg}
                                   widthAuto={config.widthAuto}/>);
    }
    case 'fileUploadNew': {
        return decorator({
            initialValue: { src: config.defaultValue }
        })(<FileUploadNew action={config.action} max={config.max} disabled={config.disabled} extra={config.extra}
                       addClass={config.addClass} onChange={config.onChange} accept={config.accept}/>);
    }
    case 'fileUpload': {
        return decorator({
            initialValue: { src: config.defaultValue }
        })(<FileUpload action={config.action} max={config.max} disabled={config.disabled} extra={config.extra}
                       addClass={config.addClass} onChange={config.onChange} accept={config.accept}/>);
    }
    case 'encryptUpload': {
        return decorator({
            validateTrigger: 'onChange'
        })(<EncryptUpload action={config.action} beforeUpload={config.beforeUpload} max={config.max}
                          disabled={config.disabled} readOnly={config.readOnly}
                          tips={config.tips} addClass={config.addClass} extension={config.extension}
                          initialValue={config.defaultValue}/>);
    }
    case 'encryptUploadMulti': {
        return decorator({
            validateTrigger: 'onChange'
        })(<EncryptUploadMulti action={config.action} max={config.max}
            disabled={config.disabled} readOnly={config.readOnly}
            tips={config.tips} addClass={config.addClass} extension={config.extension}
            initialValue={config.defaultValue} />);
    }
    case 'excelUpload': {
        return decorator()(<ExcelUpload text={config.text}
                                        extension={config.extension}
                                        templateUrl={config.templateUrl}/>);
    }
    case 'phone': {
        return decorator()(<Phone lang={config.lang} placeholder={(config.placeholder || '').split(',')}
                                  staticView={config.staticView} initialValue={config.defaultValue}
                                  disabled={config.disabled} ipconfig={config.ipConfig}
                                  showDecrypt={config.showDecrypt} decryptConfig={config.decryptConfig}
                                  preventIpConfig={config.preventIpConfig} extension={config.extension} countryList={config.countryList} />);
    }
    case 'phoneTemp': {
        return decorator()(<PhoneTemp lang={config.lang} placeholder={(config.placeholder || '').split(',')}
                                  staticView={config.staticView} initialValue={config.defaultValue}
                                  disabled={config.disabled} ipconfig={config.ipConfig} phone_country={config.phone_country}
                                  showDecrypt={config.showDecrypt} decryptConfig={config.decryptConfig} contentType={config.contentType}
                                  preventIpConfig={config.preventIpConfig} extension={config.extension} countryList={config.countryList} />);
    }
    case 'selectGroup': {
        return decorator()(<SelectGroup lang={config.lang} placeholder={(config.placeholder || '').split(',')}
                                        staticView={config.staticView} initialValue={config.defaultValue}
                                        onChange={config.onChange}
                                        disabled={config.disabled} options={config.options}
                                        extension={config.extension}/>);
    }
    case 'certificate': {
        return decorator()(<Certificate placeholder={config.placeholder} initialValue={config.defaultValue}
                                        disabled={config.disabled} staticView={config.staticView}/>);
    }
    case 'code': {
        return Code(config, decorator());
    }
    case 'imgCode': {
        return decorator({
            validateTrigger: 'onBlur'
        })(<ImgCode refreshCallback={config.refreshCallback} height={config.height} width={config.width} inputChange={config.inputChange}
                    remoteValidate={config.remoteValidate} placeholder={config.placeholder}/>);
    }
    case 'password': {
        return decorator()(<Password placeholder={config.placeholder} initialValue={config.defaultValue}
                     level={config.level} isVerifiable={config.isVerifiable}
                     disabled={config.disabled} showEye={config.showEye}/>);
    }
    case 'cascade': {
        return decorator({
            validateTrigger: 'onChange'
        })(<Cascade options={config.options} url={config.url} placeholder={config.placeholder}
                    changeOnSelect={config.changeOnSelect} loadData={config.loadData} loadCountry={config.loadCountry}
                    disabled={config.disabled} size={config.size} staticView={config.staticView} staticValue={config.staticValue}
                    formatFn={config.formatFn} onChange={config.onChange} displayRender={config.displayRender}/>);
    }
    case 'checkboxGroup': {
        return decorator({
            validateTrigger: 'onChange'
        })(<CheckboxGroup disabled={config.disabled} options={config.options} onChange={config.onChange}/>);
    }
    case 'transfer': {
        return decorator({
            initialValue: config.targetKeys
        })(<Transfer {...config}/>);
    }
    case 'switch': {
        return decorator()(<Switch defaultChecked={config.defaultValue} checkedChildren={<CheckOutlined />}
                                   unCheckedChildren={<CloseOutlined />}/>);
    }
    case 'inputNumber': {
        return decorator()(<InputNumber placeholder={config.placeholder} min={config.min} max={config.max}
                                        disabled={config.disabled}
                                        step={config.step} style={config.wrapperStyle}/>);
    }
    case 'textArea': {
        return decorator()(<TextArea placeholder={config.placeholder} rows={config.rows} disabled={config.disabled}
                                     style={{ width: '100%', minHeight: 30 }}
                                     autosize={config.autosize || { minRows: 1, maxRows: 10 }}/>);
    }
    case 'captcha': {
        return decorator({
            validateTrigger: 'onChange'
        })(<Captcha lang={config.lang} onCall={config.onCall} lazyValidate={config.lazy}
                    extension={config.extension} isDestroy={config.isDestroy} name={config.name}
                    onChange={config.onChange}/>);
    }
    case 'insertText': {
        return decorator()(<InsertText labelBefore={config.labelBefore} labelAfter={config.labelAfter}
                                       tips={config.tips}
                                       min={config.min} max={config.max} disabled={config.disabled}
                                       getValidateVal={config.getValidateVal}
                                       step={config.step} initialValue={config.defaultValue}/>);
    }
    case 'insertRadio': {
        return decorator()(<InsertRadio labelBefore={config.labelBefore} labelAfter={config.labelAfter}
                                        options={config.options}
                                        radioConfig={config}
                                        disabled={config.disabled}
                                        tips={config.tips}
                                        onChange={config.onChange}
                                        initialValue={config.defaultValue}/>);
    }
    case 'insertSwitch': {
        return decorator()(<InsertSwitch
                                       tips={config.tips} options={config.options} typeList={config.typeList}
                                       disabled={config.disabled}
                                       getValidateVal={config.getValidateVal}
                                       switchConfig={config.switchConfig}
                                       initialValue={config.defaultValue}/>);
    }
    case 'iconsPicker': {
        return decorator()(<IconsPicker placeholder={config.placeholder} initialValue={config.defaultValue}
                                        disabled={config.disabled} onChange={config.onChange}
                                        staticView={config.staticView}/>);
    }
    case 'bgImg': {
        return decorator()(<BgImg onChange={config.onChange} disabled={config.disabled} staticView={config.staticView}
                                  selected={config.selected} pictures={config.pictures} addClass={config.addClass}/>);
    }
    case 'transform': {
        return decorator({
            initialValue: config.amount
        })(<Transform {...config}/>);
    }
    case 'user': {
        return decorator()(<Match placeholder={config.placeholder} initialValue={config.defaultValue}
                                  onDeselect={config.onDeselect}
                                  allowClear={config.allowClear} disabled={config.disabled} onSelect={config.onSelect}
                                  onChange={config.onChange}
                                  size={config.size} staticView={config.staticView} link={config.link}
                                  readOnly={config.readOnly}
                                  callback={config.callback} showUuid={config.showUuid} role={config.role}
                                  defaultInfo={config.defaultInfo} showName={config.showName}
                                  filter={config.filter}
                                  nameConfig={config.nameConfig}/>);
    }
    case 'signature': {
        return decorator()(<Signature lang={config.lang} placeholder={(config.placeholder || '').split(',')}
                                      staticView={config.staticView} initialValue={config.defaultValue}
                                      disabled={config.disabled} onChange={config.onChange}/>);
    }
    case 'address': {
        return decorator()(<Address initialValue={config.defaultValue}
            staticView={config.staticView} disabled={config.disabled}
            transToEnglish={config.transToEnglish}
            onChange={config.onChange}
            transValue = {config.transValue} english={config.english} destroyTransValue={config.destroyTransValue}/>);
    }
    case 'dynamicSelect': {
        return decorator()(<DynamicSelect lang={config.lang} placeholder={(config.placeholder || '').split(',')}
            staticView={config.staticView} initialValue={config.defaultValue}
            onChange={config.onChange}
            disabled={config.disabled} options={config.options}
            extension={config.extension} />);
    }
    case 'areaSelectInput': {
        return decorator()(<AreaSelectInput lang={config.lang} placeholder={(config.placeholder || '').split(',')}
            staticView={config.staticView} initialValue={config.defaultValue}
            onChange={config.onChange}
            disabled={config.disabled} options={config.options}
            extension={config.extension} />);
    }
    case 'checkBoxInput': {
        return decorator()(<CheckBoxInput staticView={config.staticView} disabled={config.disabled} options={config.options}/>);
    }
    case 'complexAddress': {
        return decorator()(
            <ComplexAddress initialValue={config.defaultValue}
            staticView={config.staticView} disabled={config.disabled}
            onChange={config.onChange} options={config.options} url={config.url} placeholder={config.placeholder}
            changeOnSelect={config.changeOnSelect} loadData={config.loadData} loadCountry={config.loadCountry}
            size={config.size} formatFn={config.formatFn} displayRender={config.displayRender}/>
        );
    }
    case 'selectInput': {
        return decorator()(
            <SelectInput initialValue={config.defaultValue}
            allowClear={config.allowClear} staticView={config.staticView} disabled={config.disabled}
            onChange={config.onChange} options={config.options} placeholder={config.placeholder}
            />
        );
    }
}};
